import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import React from "react";
import { RTF } from "../elements/RTF";

interface Props {
  title?: string;
  message?: IRichTextInformation;
}
export const ListItem: React.FC<Props> = (props) => {
  const { title, message } = props;
  return (
    <div className={classNames("mb-60px", "lg:mb-96px")}>
      {title && <h3 className="h4 relative mb-20px text-hyacinth">{title}</h3>}
      {message && <RTF fixedParagraphClassName="p4" content={message} />}
    </div>
  );
};
